class GiftOptions extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.message = this.querySelector('textarea');
    this.button = this.querySelector('.gift-options__save');
    this.status = this.querySelector('[role="status"]');
    this.variantIds = [...this.select.options].map(option => Number(option.value)).filter(Boolean);
    this.querySelector('.gift-options__message').hidden = !this.hasCard();
    this.button.disabled = false;
    this.select.addEventListener('change', () => {
      this.querySelector('.gift-options__message').hidden = !this.hasCard();
    });
    this.button.addEventListener('click', () => this.save());
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
        if (GiftOptions.busy) return;
        try {
          const cart = await this.request('cart.js');
          if (!this.isConnected) return;
          const gift = cart.items.find(item => this.variantIds.includes(item.variant_id));
          this.select.value = String(gift?.variant_id || 0);
          this.message.value = gift?.properties?.['Gift message'] || '';
          this.querySelector('.gift-options__message').hidden = !this.hasCard();
        } catch (_) {
          this.status.textContent = this.dataset.error;
        }
      });
    }
  }
  disconnectedCallback() {
    this.unsubscribe?.();
  }
  hasCard() {
    return this.select.selectedOptions[0]?.dataset.card === 'true';
  }
  async request(path, body) {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(this.dataset.error);
    return data;
  }
  async save() {
    if (GiftOptions.busy) return;
    GiftOptions.busy = true;
    const selectedId = Number(this.select.value);
    const message = this.hasCard() ? this.message.value.trim() : '';
    this.querySelector('fieldset').disabled = true;
    this.status.textContent = this.dataset.saving;
    const blockInteractions = event => {
      if (event.target.closest('cart-items, cart-drawer, #main-cart-footer, a[href*="checkout"]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    document.addEventListener('click', blockInteractions, true);
    document.addEventListener('submit', blockInteractions, true);
    try {
      const cart = await this.request('cart.js');
      const gifts = cart.items.filter(item => this.variantIds.includes(item.variant_id));
      if (selectedId && !cart.items.some(item => !this.variantIds.includes(item.variant_id))) {
        throw new Error(this.dataset.required);
      }
      let keptKey;
      const existing = gifts.find(item => item.variant_id === selectedId);
      if (selectedId && existing) {
        const properties = { ...existing.properties, 'Gift message': message };
        const updated = await this.request('cart/change.js', { id: existing.key, quantity: 1, properties });
        keptKey = updated.items.find(item => item.variant_id === selectedId)?.key;
      } else if (selectedId) {
        const added = await this.request('cart/add.js', { items: [{ id: selectedId, quantity: 1, properties: { 'Gift message': message } }] });
        keptKey = added.items[0].key;
      }
      const current = await this.request('cart.js');
      const updates = Object.fromEntries(current.items
        .filter(item => this.variantIds.includes(item.variant_id) && item.key !== keptKey)
        .map(item => [item.key, 0]));
      if (Object.keys(updates).length) await this.request('cart/update.js', { updates });
      const verified = await this.request('cart.js');
      const result = verified.items.filter(item => this.variantIds.includes(item.variant_id));
      if (selectedId ? result.length !== 1 || result[0].variant_id !== selectedId || result[0].quantity !== 1 || (result[0].properties?.['Gift message'] || '') !== message : result.length !== 0) {
        throw new Error(this.dataset.error);
      }
      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      this.status.textContent = error.message === this.dataset.required ? error.message : this.dataset.error;
      this.querySelector('.gift-options__refresh').hidden = false;
    } finally {
      document.removeEventListener('click', blockInteractions, true);
      document.removeEventListener('submit', blockInteractions, true);
      this.querySelector('fieldset').disabled = false;
      GiftOptions.busy = false;
    }
  }
}
if (!customElements.get('gift-options')) customElements.define('gift-options', GiftOptions);
